// TEST-039/043: read-only view of client + Alias change requests (plain React text — escaped).
const BADGE = {
  applied: ["Applied", "bg-emerald-500/15 text-emerald-300"],
  needs_review: ["Needs Alias review", "bg-amber-500/15 text-amber-300"],
  unsupported: ["Not supported in V1", "bg-rose-500/15 text-rose-300"],
  pending: ["Waiting to be processed", "bg-slate-700/60 text-slate-300"],
};

function Item({ it, i, rid }) {
  const [label, cls] = BADGE[it.outcome] || BADGE.pending;
  return (
    <li className="rounded-xl bg-slate-950/60 ring-1 ring-slate-800 p-3 space-y-1" data-testid={`request-${rid}-item-${i}`}>
      <p className="text-xs font-semibold text-slate-300 flex flex-wrap gap-2 items-center">
        {[it.category, it.area].filter(Boolean).join(" · ") || "Change"}
        <span className={`rounded px-1.5 py-0.5 text-[10px] ${cls}`} data-testid={`request-${rid}-outcome-${i}`}>{label}</span>
      </p>
      <p className="text-sm text-slate-100 whitespace-pre-wrap break-words" data-testid={`request-${rid}-text-${i}`}>{it.request}</p>
      {it.explanation && <p className="text-xs text-slate-400" data-testid={`request-${rid}-explain-${i}`}>{it.explanation}</p>}
      {it.changes.map((c, k) => (
        <div key={k} className="text-xs rounded-lg bg-slate-900 p-2 space-y-0.5" data-testid={`request-${rid}-change-${i}-${k}`}>
          <p className="text-slate-500">{c.section}</p>
          <p className="text-slate-500 line-through whitespace-pre-wrap break-words">{c.before}</p>
          <p className="text-emerald-200 whitespace-pre-wrap break-words">{c.after}</p>
        </div>
      ))}
    </li>
  );
}

export function ClientRequests({ requests }) {
  if (!requests || requests.length === 0) return null;
  return (
    <section className="rounded-2xl bg-slate-900/70 ring-1 ring-sky-500/30 p-4 space-y-4" data-testid="client-requests">
      <p className="text-[11px] uppercase tracking-wide text-sky-300/90">Change requests</p>
      {[...requests].reverse().map((r) => (
        <div key={r.id} className="space-y-2" data-testid={`client-request-${r.id}`}>
          <p className="text-xs text-slate-400" data-testid={`client-request-meta-${r.id}`}>
            <span className="font-semibold text-slate-200">{r.by === "alias" ? "Alias (internal — no client revision used)" : "Client"}</span>
            {" · "}sent {r.submittedAt ? new Date(r.submittedAt).toLocaleString() : "—"} about {r.baseVersion}
            {r.clientName ? ` by ${r.clientName}` : ""}
            {r.resultVersion ? ` · result: ${r.resultVersion}` : ""}
          </p>
          {r.failed && <p className="text-xs text-rose-300" data-testid={`client-request-failed-${r.id}`}>Could not be processed: {r.failed}</p>}
          <ul className="space-y-2">{r.items.map((it, i) => <Item key={i} it={it} i={i} rid={r.id} />)}</ul>
        </div>
      ))}
    </section>
  );
}
